import { GraphQLError } from 'graphql';
import { Errors } from '../../Shared/Errors';

type APIErrors =
  | Errors.AccountLockedError
  | Errors.InternalServerError
  | Errors.InvalidCredentialsError
  | Errors.InvalidArgumentError
  | Errors.NotFoundError
  | Errors.RateLimitError
  | Errors.TokenExpiredError
  | Errors.UnauthorizedError;

const ApiErrorMessages: { [name in APIErrors]: string } = {
  [Errors.AccountLockedError]: 'Account temporarily disabled',
  [Errors.InternalServerError]: 'Internal server error',
  [Errors.InvalidCredentialsError]: 'Invalid credentials',
  [Errors.InvalidArgumentError]: 'InvalidArgumentError',
  [Errors.NotFoundError]: 'NotFoundError',
  [Errors.RateLimitError]: 'Rate limit reached',
  [Errors.TokenExpiredError]: 'Access token expired',
  [Errors.UnauthorizedError]: 'Unauthorized',
};

/**
 * Creates a GraphQLError with the 'name' property on the error
 * to match the way the API returns errors.
 *
 * Do not use for frontend error types e.g. UnrecognisedSubdomain
 * as these have a different format
 *
 * TODO: Migrate errors to follow GraphQL spec so this is no longer required
 */
export function createMockAPIError(name: APIErrors) {
  return { name, message: ApiErrorMessages[name] } as GraphQLError;
}
